import { H3, Link } from '@codex/basics';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

export const BoxWrapper = styled.div`
  ${({ theme }) => theme.fonts.default};
  display: flex;
  flex-direction: column;

  > ${H3} {
    color: ${({ theme }) => theme.colors.shades[1]};
    font-weight: ${({ theme }) => theme.fontWeights.normal};
    
    ${Link} {
      margin-left: ${({ theme }) => theme.spacing[2]};
      font-size: 13px;
    }
  }
`;

const HomepageBox = props => (
  <BoxWrapper className={props.className}>
    <H3>{props.title}</H3>
    {props.children}
  </BoxWrapper>
);

HomepageBox.propTypes = {
  className: PropTypes.string,
  title: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired
};

HomepageBox.defaultProps = {
  className: undefined
};

/** @component */
export default styled(HomepageBox)``;
